import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const CircleCheckFilledIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' {...props} ref={ref}>
        <path
            fill='currentColor'
            d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM16.6641 8.75293C16.2513 8.38601 15.6199 8.42315 15.2529 8.83594L10.667 13.9951L8.74707 11.8359C8.38016 11.4232 7.74873 11.386 7.33594 11.7529C6.92315 12.1198 6.88601 12.7513 7.25293 13.1641L9.91895 16.1641C10.1087 16.3772 10.3816 16.5 10.667 16.5C10.9523 16.4997 11.2245 16.3773 11.4141 16.1641L16.7471 10.1641C17.1138 9.75147 17.0763 9.11992 16.6641 8.75293Z'
        />
    </svg>
));
